import { z } from 'zod'

/**
 * Schema for organization settings update
 * Validates name and optional logoUrl for organization
 */
export const organizationSettingsSchema = z.object({
  name: z
    .string()
    .min(2, 'Organization name must be at least 2 characters')
    .max(100, 'Organization name must be at most 100 characters'),
  logoUrl: z.string().url('Invalid URL format').nullable().optional(),
})

/**
 * Input type for organization settings update
 */
export type OrganizationSettingsInput = z.infer<typeof organizationSettingsSchema>

/**
 * Schema for organization details response
 */
export const organizationDetailsSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  logoUrl: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
})

/**
 * Type for organization details
 */
export type OrganizationDetails = z.infer<typeof organizationDetailsSchema>
